var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewSubmission(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4C16.4182 4 20 7.58145 20 12C20 16.4182 16.4182 20 12 20C7.58182 20 4 16.4182 4 12C4 7.58145 7.58182 4 12 4Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7C12.2301 7 12.417 7.18687 12.417 7.41699V11.583H16.583C16.8131 11.583 17 11.7699 17 12C17 12.2301 16.8131 12.417 16.583 12.417H12.417V16.583C12.417 16.8131 12.2301 17 12 17C11.7699 17 11.583 16.8131 11.583 16.583V12.417H7.41699C7.18687 12.417 7 12.2301 7 12C7 11.7699 7.18687 11.583 7.41699 11.583H11.583V7.41699C11.583 7.18687 11.7699 7 12 7Z",
    fill: "#081e56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewSubmission);
export default __webpack_public_path__ + "static/media/new-submission.2cc4a36071046a018c60ccca986d1cb3.svg";
export { ForwardRef as ReactComponent };